var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner border-none border-2 rounded-full",class:[("border-" + _vm.color)],style:({ width: _vm.radiusInPixels, height: _vm.radiusInPixels, borderWidth: _vm.thicknessInPixels })})}
var staticRenderFns = []

export { render, staticRenderFns }